import { defineMessages } from "react-intl";

const messages = defineMessages({
    dashboard: {
        id: "choir.choir.myChoirs",
    },
    slogen: {
        id: "choir.slogen",
    },
});

export default messages;
